import { GenericError, IErrorDetails } from '@cian/peperrors/shared';
import { ESubdomain, EErrorType, DOMAIN } from '../constants/domain';

export class UpdateVacancyDateError extends GenericError {
  public constructor(configuration: { subdomain: ESubdomain; message: string; details?: IErrorDetails }) {
    super({
      ...configuration,
      domain: `${DOMAIN}#${configuration.subdomain}`,
      type: EErrorType.UpdateVacancyDateError,
    });

    // Необходимо из-за особенности реализации наследования в TS. Иначе не будет работать instanceof NotFoundError
    Object.setPrototypeOf(this, UpdateVacancyDateError.prototype);

    // Данный код не является обязательным, он нужен для того, чтобы не было лишнего слоя в стэктрейсе
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, UpdateVacancyDateError);
    } else {
      this.stack = new Error().stack;
    }
  }
}
